import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';
import { IImage } from '../../annotation/annotations.interface';
import { IAnnotationsStore } from '../../annotation/annotations.store';

interface IAnnotationPreviewRenderProps {
  image?: IImage;
}

interface IProps {
  children(props: IAnnotationPreviewRenderProps): ReactNode;
}

export const AnnotationPreviewContainer = observer((props: IProps): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);

  return (
    <>
      {props.children({
        image: annotationsStore.image,
      })}
    </>
  );
});
